export default __webpack_public_path__ + "static/media/ReportIcon-Diabetes-MS.3291f37f.jpg";